import {Icon} from '@components/@icons';
import {InputAdornment} from '@mui/material';
import {ActivityService} from '@services/activity/activity.service';
import classNames from 'classnames';
import {FC} from 'react';
import {IInputProps, MeinInput} from '../Input/MeinInput';
import styles from './MeinInputSearch.module.css';

interface IMeinInputSearchProps extends Omit<IInputProps, 'onChange'> {
    onChange: (value: string) => void;
}

export const MeinInputSearch: FC<IMeinInputSearchProps> = ({
    value,
    onChange,
    ...props
}) => {
    const shouldShowClear = Boolean(value && String(value).length > 0);

    const handleClear = () => {
        ActivityService.logElementClick({
            resource_id: 'btn_clear_search',
        });
        onChange?.('');
    };

    return (
        <MeinInput
            type="search"
            size="small"
            value={value}
            onChange={e => onChange(e.target.value)}
            inputClassname={styles.input}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start">
                            <Icon
                                name="search"
                                className={styles.icon}
                                color="var(--color-icon-secondary)"
                            />
                        </InputAdornment>
                    ),
                    endAdornment: shouldShowClear && (
                        <InputAdornment
                            position="end"
                            className={styles.clearButtonContainer}
                        >
                            <button
                                type="button"
                                className={classNames(styles.clearButton)}
                                onClick={handleClear}
                            >
                                <Icon
                                    name="close"
                                    className={styles.clearIcon}
                                />
                            </button>
                        </InputAdornment>
                    ),
                },
            }}
            {...props}
        />
    );
};
